<script setup lang="ts">
import type { CartItem } from "@/schemas/cart";

defineProps<{ cartItem: CartItem }>();
const { onRemoveFromCart, isDisabled, icon } = useRemoveFromCart();
</script>

<template>
  <button type="button" :disabled="isDisabled" class="flex text-danger opacity-50 transition hover:opacity-100" @click="onRemoveFromCart({ cart_item_key: cartItem.key })">
    <span class="size-6" :class="icon" />
  </button>
</template>
